export default [/line-clamp-(\d+)/, (match) => ({
    overflow: 'hidden',
    display: '-webkit-box',
    // These work for the browser
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: match[1],
    // These work for unit tests, until this gets merged: https://github.com/jsdom/cssstyle/pull/112
    webkitBoxOrient: 'vertical',
    webkitLineClamp: match[1],
})]